<template>
  <section>
    <nav
      class="header-navbar navbar navbar-expand-lg align-items-center navbar-shadow fixed-top navbar-light"
    >
      <div class="navbar-container d-flex content">
        <div class="bookmark-wrapper d-flex align-items-center">
          <ul class="nav navbar-nav bookmark-icons">
            <li class="nav-item d-none d-lg-block">
              <router-link
                class="nav-link"
                to="/settings/project"
                data-toggle="tooltip"
                data-placement="top"
                title="Настройки портала"
                >Настройки</router-link
              >
            </li>
            <li
              v-if="project_mode !== 'vityaz'"

              class="nav-item d-none d-lg-block"
            >
              <router-link
                class="nav-link"
                to="/journals"
                data-toggle="tooltip"
                data-placement="top"
                title="Журналы"
                >Журналы</router-link
              >
            </li>
            <li
              v-if="project_mode !== 'vityaz'"
              class="nav-item d-none d-lg-block"
            >
              <router-link
                class="nav-link"
                to="/protocols"
                data-toggle="tooltip"
                data-placement="top"
                title="Протоколы"
                >Протоколы</router-link
              >
            </li>
            <li
              v-for="project in projects.slice(0, 3)"
              class="nav-item d-none d-lg-block"
            >
              <router-link
                class="nav-link"
                :to="'/project/' + project['id'] + '/organization'"
                data-toggle="tooltip"
                data-placement="top"
                >{{ project["short_name"] }}</router-link
              >
            </li>
            <li class="nav-item dropdown" v-if="projects.length > 3">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="contestSelect"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Перейти к проекту <font-awesome-icon icon="fas fa-angle-down" />
              </a>
              <div class="dropdown-menu" aria-labelledby="contestSelect">
                <template v-for="(project, index) in projects">
                  <router-link
                    v-if="index >= 3"
                    class="dropdown-item"
                    :to="'/project/' + project['id'] + '/organization'"
                    >{{ project["short_name"] }}</router-link
                  >
                </template>
              </div>
            </li>
          </ul>
        </div>
        <ul class="nav navbar-nav align-items-center ml-auto">
          <li class="nav-item">
            <div class="user-nav" v-if="user.name">
              <p
                class="user-name py-0 my-0 font-weight-bolder"
                style="font-size: 14px"
              >
                Добро пожаловать, {{ user.name }}!
              </p>
              <p
                class="user-name py-0 my-0"
                style="font-size: 10px"
                v-if="users.length > 0"
              >
                (Сейчас на сайте: <b>{{ users.length }}</b
                >)
              </p>
            </div>
          </li>
        </ul>
      </div>
    </nav>

    <div
      class="main-menu menu-fixed menu-light menu-accordion menu-shadow"
      data-scroll-to-active="true"
    >
      <div class="navbar-header">
        <ul class="nav navbar-nav flex-row">
          <li class="nav-item mr-auto">
<!--            <span v-if="project_mode === 'vityaz'" class="navbar-brand"-->
<!--              ><img src="/images/vityaz.jpeg" width="34" height="40" alt=""-->
<!--            /></span>-->
          </li>
        </ul>
      </div>
      <div class="shadow-bottom"></div>
      <sidebar-menu></sidebar-menu>
    </div>

    <router-view></router-view>
  </section>
</template>

<script>
import Auth from "../../Auth.js";
import SidebarMenu from "../SidebarMenu.vue";
export default {
  components: {
    SidebarMenu,
  },
  data() {
    return {
      projects: [],
      user: {
        id: null,
        name: null,
      },
      users: [],
      project_mode: process.env.MIX_PROJECT_MODE || "uib",
    };
  },
  methods: {
    initUser() {
      if (!Auth.user) {
        Swal.fire({
          title: "Пожалуйста представьтесь",
          html:
            '<input id="swal-input1" class="swal2-input" placeholder="Логин">' +
            '<input id="swal-input2" class="swal2-input" type="password" placeholder="Пароль">',
          focusConfirm: false,
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showLoaderOnConfirm: true,
          backdrop: `rgba(0,0,0,0.90)`, // Сильное затемнение фона (95% непрозрачности)
          preConfirm: () => {
            const login = document.getElementById("swal-input1").value;
            const password = document.getElementById("swal-input2").value;

            const data = new FormData();
            data.append("user_name", login);
            data.append("password", password);

            // Возвращаем промис запроса
            return axios
              .post("/api/login", data)
              .then(({ data }) => {
                return data; // Передаем данные дальше в .then(result)
              })
              .catch(({ response }) => {
                // Показываем ошибку и не закрываем окно
                Swal.showValidationMessage(
                  response && response.data.message
                    ? response.data.message
                    : "Ошибка авторизации"
                );
              });
          },
        }).then((result) => {
          if (result.value) {
            // Успешный вход
            Auth.login(result.value.token, result.value.user);
            this.$Progress.finish();
            window.location.href = "/settings/project";
          }
        });
      } else {
        this.user = Auth.user;
      }
    },
    loadProjects() {
      axios.get("/api/project?page=1&search=&perPage=1000").then(({ data }) => {
        this.projects = data.data;
      });
    },
    logout() {
      Swal.fire({
        title: "Вы действительно хотите выйти?",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#7367f0",
        confirmButtonText: "Да",
        cancelButtonText: "Отмена",
      }).then((result) => {
        if (result.value) {
          Auth.logout();
          window.location.href = "/login";
        }
      });
    },
  },
  created() {
    this.$Progress.start();
    this.loadProjects();
    this.initUser();
    this.$Progress.finish();
    window.Echo.join(`onlineusers`)
      .here((users) => {
        users.forEach((user) => {
          if (this.user.id !== user.id) {
            this.users.push(user);
          }
        });
      })
      .joining((user) => {
        this.users.push(user);
      })
      .leaving((user) => {
        this.users.forEach((item, i) => {
          if (item.id === user.id) {
            this.users.splice(i, 1);
          }
        });
      });
  },
};
</script>
